namespace Nobox.Chat {
    export interface perHour {
        Count?: number;
        Hour?: number;
    }
}
